'use client';

import '@ui5/webcomponents/dist/TabContainer.js';
import { TabContainerBackgroundDesign, TabLayout, TabsOverflowMode } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `TabContainer` represents a collection of tabs with associated content. Navigation through the tabs changes the content display of the currently active content area. A tab can be labeled with text only, or icons with text.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-TabContainer)
 */
const TabContainer = withWebComponent('ui5-tabcontainer', ['contentBackgroundDesign', 'headerBackgroundDesign', 'tabLayout', 'tabsOverflowMode'], ['collapsed', 'fixed', 'showOverflow'], ['overflowButton', 'startOverflowButton'], ['tab-select']);
TabContainer.displayName = 'TabContainer';
TabContainer.defaultProps = {
  contentBackgroundDesign: TabContainerBackgroundDesign.Solid,
  headerBackgroundDesign: TabContainerBackgroundDesign.Solid,
  tabLayout: TabLayout.Standard,
  tabsOverflowMode: TabsOverflowMode.End
};
export { TabContainer };